import Marquee from "react-fast-marquee";

const ITEMS = [
  "Buď autentický",
  "Přijmi odpovědnost za svůj život",
  "Jednej navzdory strachu",
  "Říkej, co skutečně chceš",
  "Dodržuj své slovo",
  "Uměj odejít",
  "Selhání proměň ve zkušenost",
  "Nikdy nejsi hotový",
];

export const EditorialMarquee = () => (
  <div
    className="border-y border-white/[0.06] bg-navy-deep py-6"
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <Marquee speed={26} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-16 font-serif text-lg italic text-copper/80">
          {item}
          <span className="ml-16 inline-block h-1.5 w-1.5 rounded-full bg-copper/50" />
        </span>
      ))}
    </Marquee>
  </div>
);
